import { Box, Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import RareIcon from "../../../../assets/images/coelho/raro-icon.svg";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import { amber } from "@mui/material/colors";
import { colors } from "../../../../theme/colors";
import { useBRLmoney } from "../../../../hooks/useBRLmoney";
import useCart from "../../../../hooks/context/useCart";
import useAuth from "../../../../hooks/context/useAuth";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";

export function ProductCard({
  item,
}: {
  item: Omit<ProductData, "Manufacturers" | "Versions" | "Origin">;
}) {
  const nav = useNavigate();
  const { BRLmoney } = useBRLmoney();
  const { addToMyCart } = useCart();
  const { user } = useAuth();
  const { isMobile } = useBreakpoints();

  const addToCart = async () => {
    if (!user) {
      nav("/user/login");
    } else {
      await addToMyCart(
        {
          cartID: user?.cartID,
          productID: item?.id,
          quantity: 1,
        },
        true
      );
    }
  };

  if (!item) return <></>;
  return (
    <Box
      width={151}
      display={"flex"}
      flexDirection={"column"}
      sx={{
        maxHeight: 435,
        boxShadow: "0px 4px 14px -2px #0000002E",
        width: isMobile ? "150px" : "280px",
        height: "Hug (410x)px",
        padding: "8px",
        gap: "8px",
        borderRadius: "12px",
        opacity: " 0px",
        transition: "0.4s ease",
        background: "#FFFFFF",
        "&: hover": {
          cursor: "pointer",
          transform: "scale(1.05)",
        },
        // "&:not(:hover)": { zoom: 0, transition: "200ms ease-in-out" },
      }}
    >
      <Link
        to={`/details?product=${item?.id}`}
        rel="noopener noreferrer"
        style={{
          textDecoration: "none",
          color: "inherit",
        }}
      >
        {item?.isRare && (
          <Box
            style={{
              position: "absolute",
              zIndex: 500,
              width: 50,
              marginLeft: isMobile ? 100 : 250,
              marginTop: -40,
              borderRadius: 5,
              color: "#FFFFFF",
              textAlign: "center",
              transform: "rotate(20deg)",
            }}
          >
            <img src={RareIcon} alt="icone de raro" width={70} />
          </Box>
        )}
        <img
          src={item?.productsImages[0]?.code}
          width={isMobile ? 140 : 264}
          height={isMobile ? 140 : 264}
          alt={"product"}
          style={{ borderRadius: "12px 0px 0px 0px", objectFit: "contain" }}
        />
        <Box height={24} display={"flex"} gap={1}>
          {item?.stock <= 5 && item?.stock > 0 && (
            <Typography
              sx={{
                fontSize: isMobile ? 12 : "16px",
                fontWeight: 700,
                textAlign: "left",
                color: amber[400],
                wordBreak: "break-word",
              }}
            >
              Quase esgotando
            </Typography>
          )}
          {item?.stock === 0 && (
            <Typography
              sx={{
                fontSize: isMobile ? 12 : "16px",
                fontWeight: 700,
                textAlign: "left",
                color: colors.red[400],
                wordBreak: "break-word",
              }}
            >
              Esgotado
            </Typography>
          )}
          {item?.discountPrice > 0 && (
            <Typography
              sx={{
                mt: isMobile ? 1 : 0,
                fontSize: isMobile ? 12 : "16px",
                fontWeight: 700,
                textAlign: "left",
                color: colors.green[400],
              }}
            >
              Promoção
            </Typography>
          )}
        </Box>
        <Typography
          sx={{
            mt: isMobile ? 3 : 0,
            fontSize: "16px",
            fontWeight: 400,
            textAlign: "left",
            color: colors.textGrey[500],
            wordBreak: "break-word",
            height: 48,
          }}
        >
          {item?.name}
        </Typography>

        {item?.discountPrice > 0 ? (
          <Box display={"flex"} flexWrap={"wrap"} gap={isMobile ? 0 : 1}>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 700,
                textAlign: "left",
                color: colors.green[400],
              }}
            >
              {BRLmoney(item?.discountPrice)}
            </Typography>
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 500,
                textAlign: "left",
                color: colors.textGrey[500],
                textDecoration: "line-through",
                minHeight: isMobile ? "auto" : 52,
              }}
            >
              {BRLmoney(item?.price)}
            </Typography>
          </Box>
        ) : (
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 500,
              textAlign: "left",
              color: colors.textGrey[500],
              minHeight: 52,
            }}
          >
            {BRLmoney(item?.price)}
          </Typography>
        )}
      </Link>
      <Button
        sx={{
          background: colors.purpleAlpha[400],
          color: colors.textGrey[500],
          fontSize: 12,
          "&:disabled": {
            background: colors.gray[100],
          },
        }}
        fullWidth
        onClick={addToCart}
        disabled={item.stock === 0}
      >
        <ShoppingCartCheckoutIcon /> Adicionar ao carrinho
      </Button>
    </Box>
  );
}
